import {
	mapActions
} from "vuex";
import moment from "moment";

import getMvcUrl from "../../utils/mvcUrlUtil.js";
import numberFormat from "../../utils/common.js";
import tableColumnDecrypt from "@/components/table-column-decrypt";
export default {
	name: "companyQualification",
	components: {
		tableColumnDecrypt
	},
	data() {
		return {
			obj: {},
			drawer: false,
			direction: 'rtl',
			url: null,
			srcList: []
		};
	},
	methods: {
		...mapActions([
			"getCompanyQualificationInfoApi"
		]),
		getCompanyQualificationInfo() {
			this.obj = {};
			this.getCompanyQualificationInfoApi(null).then(res => {
				this.obj = res;
			});
		},
		handleClose(done) {
			done();
		},
		handleClose2(done) {
			done();
		},
		linkFile(type) {
			//1=营业执照,2=证明材料,3=法人授权委托书
			let filename = this.getFileNameByType(type);
			if(!filename){
				this.$message({type: "error",message: '文件不存在！'});
				return;
			}
			if (this.calcIconType(filename) === 'img') {
				this.drawer = true;
				this.switchImg(type);
			} else {
				this.fileDownLoad(type);
			}
		},
		calcIconType(v) {
			if (v) {
				let imgs = ['jpg', 'jpeg', 'gif', 'png', 'bmp'];
				for (let i = 0; i < imgs.length; i++) {
					if (v.toLowerCase().indexOf('.' + imgs[i]) > 0) {
						return 'img';
					}
				}
			}
			return 'file';
		},
		switchImg(type) {
			let preUrl = getMvcUrl() + '/saas/companyQualification/viewImage?objectName=';
			this.url = preUrl+this.getFileNameByType(type);
			this.srcList = [this.url];
		},
		fileDownLoad(type) {
			let preUrl = getMvcUrl() + '/saas/companyQualification/downLoadFile?objectName=' + this.getFileNameByType(type);
			window.open(preUrl);
		},
		getFileNameByType(type) {
			if (type == 1) {
				return this.obj.businessLicenseFileAddr;
			}
			if (type == 2) {
				return this.obj.mentorProveFileAddr;
			}
			if (type == 3) {
				return this.obj.attorneyFileAddress;
			}
		}
	},
	created() {

	},
	mounted() {
		this.getCompanyQualificationInfo();
	},
	computed: {
		registerCapitalFormat(){
			if(!this.obj.registerCapital){
				return 0;
			}
			return numberFormat(this.obj.registerCapital*1, 2, ".", ",");
		},
		registerDateFormat() {
			if (!this.obj.registerDate) {
				return '';
			}
			return moment(new Date(this.obj.registerDate)).format("YYYY-MM-DD");
		},
		registerDateStartFormat() {
			if (!this.obj.registerDateStart) {
				return '';
			}
			return moment(new Date(this.obj.registerDateStart)).format("YYYY-MM-DD");
		},
		registerDateEndFormat() {
			if (!this.obj.registerDateEnd) {
				return '长期';
			}
			return moment(new Date(this.obj.registerDateEnd)).format("YYYY-MM-DD");
		},
		companyTypeFormat() {
			if (this.obj.companyType == 1) {
				return '母公司';
			}
			return '子公司';
		},
		iconType1() {
			return this.calcIconType(this.getFileNameByType(1));
		},
		iconType2() {
			return this.calcIconType(this.getFileNameByType(2));
		},
		iconType3() {
			return this.calcIconType(this.getFileNameByType(3));
		}
	},
	watch: {

	}
}
